<template>
  <div class="tabs-container">
    <button v-for="tab in tabs" :key="tab" class="tab-btn" :class="{ active: currentTab === tab }"
      @click="$emit('change-tab', tab)">
      {{ tab }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: { type: String, required: true }
  },
  data() {
    return {
      tabs: ['General', 'Recovery', 'Process', 'Fees & Security', 'Getting Started']
    };
  }
}
</script>

<style scoped>
.tabs-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 20px 5% 60px;
  flex-wrap: wrap;
}

.tab-btn {
  background: transparent;
  border: 1px solid #233045;
  color: #a0b3cc;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover {
  border-color: #2ee6a8;
}

.tab-btn.active {
  background: linear-gradient(90deg, #5b6cff, #2ee6a8);
  color: #070b14;
  font-weight: bold;
  border-color: transparent;
  box-shadow: 0 0 20px rgba(46, 230, 168, 0.4);
}

@media (max-width: 768px) {
  .tab-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}
</style>